import { push } from 'redux-first-history';

export const updateStoreLocatorUrl = ({ appQueryString }) => {
  return push(`/store-locator${appQueryString ?? ''}`);
};
